/**
 * Base class for exceptions
 */
export class LensSDKException extends Error {
    constructor(errorCode, message, rawException) {
        super(message);
        this.errorCode = errorCode;
        this.message = message;
        this.rawException = rawException;
        Object.setPrototypeOf(this, LensSDKException.prototype);
        if (Error.captureStackTrace !== undefined) {
            Error.captureStackTrace(this, LensSDKException);
        }
    }
}
export class NotFoundException extends LensSDKException {
    constructor(message = "Entity not found", rawException) {
        super(404, message, rawException);
        Object.setPrototypeOf(this, NotFoundException.prototype);
    }
}
export class UnauthorizedException extends LensSDKException {
    constructor(message = "Failed to verify authorization token", rawException) {
        super(401, message, rawException);
        Object.setPrototypeOf(this, UnauthorizedException.prototype);
    }
}
export class ConflictException extends LensSDKException {
    constructor(message = "Conflict", rawException) {
        super(409, message, rawException);
        Object.setPrototypeOf(this, UnauthorizedException.prototype);
    }
}
export class ForbiddenException extends LensSDKException {
    constructor(message = "Forbidden", rawException) {
        super(403, message, rawException);
        Object.setPrototypeOf(this, ForbiddenException.prototype);
    }
}
export class TokenNotFoundException extends LensSDKException {
    constructor(message = "Token not found", rawException) {
        super(500, message, rawException);
        Object.setPrototypeOf(this, TokenNotFoundException.prototype);
    }
}
export class BadRequestException extends LensSDKException {
    constructor(message = "Bad request", rawException) {
        super(400, message, rawException);
        Object.setPrototypeOf(this, BadRequestException.prototype);
    }
}
export class UnprocessableEntityException extends LensSDKException {
    constructor(message = "Unprocessable entity", rawException) {
        super(422, message, rawException);
        Object.setPrototypeOf(this, UnprocessableEntityException.prototype);
    }
}
export class InternalServerException extends LensSDKException {
    constructor(message = "Internal server error", rawException) {
        super(500, message, rawException);
        Object.setPrototypeOf(this, InternalServerException.prototype);
    }
}
